import {DependenciesChunk} from "../chunks/types/DependenciesChunk";
import {dependenciesItemChunkToDependencyDef} from "./dependenciesItemChunkToDependencyDef";
import {DependencyDef} from "./types/DependencyDef";

export function dependenciesChunkToDependencyDef(
  dependenciesChunk: DependenciesChunk
): Array<DependencyDef> {
  const {children = []} = dependenciesChunk;
  const result: Array<DependencyDef> = [];
  for (const chunk of children) {
    const dependency = dependenciesItemChunkToDependencyDef(chunk);
    result.push(dependency);
  }
  return result;
}